module.exports = __webpack_public_path__ + "static/media/191CS147.5d502182.jpeg";